import * as actions from 'actions';
import textEditingMaker from 'reducersMakers/textEditingMaker';

export default textEditingMaker({
  submitType: actions.FEEDBACK_CREATE,
  submitSuccessType: actions.FEEDBACK_CREATE_SUCCESS,
  submitErrorType: actions.FEEDBACK_CREATE_ERROR,
  updateTextType: actions.FEEDBACK_EDITING_UPDATE_TEXT,
  resetType: actions.FEEDBACK_EDITING_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/feedback/textEditing/reducer.js
 **/